export default __webpack_public_path__ + "static/media/bfe81234661bd5578466064282c8697e1637666297824.a4ef0235.webp";